import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=dc98c8b6&"
import script from "./ActiveOrders.vue?vue&type=script&lang=js&"
export * from "./ActiveOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports